
/**
 * 防抖 hook
 * @param delay 延迟时间，默认 300ms
 * @returns
 */
export function useDebounce(fn: (args?: any, b?: any, c?: any) => void, delay = 300) {
  // 1.定义一个定时器, 保存上一次的定时器
  let timer: any = null;

  // 2.真正执行的函数
  const _debounce = function(args?: any, b?: any, c?: any) {
    // 取消上一次的定时器
    if (timer) clearTimeout(timer);
    // 延迟执行
    timer = setTimeout(() => {
      // 外部传入的真正要执行的函数
      fn(args, b, c);
    }, delay);
  };

  return _debounce;
}

/**
 * 节流 hook
 * @param fn 要执行的函数
 * @param delay 延迟时间，默认 300ms
 * @returns
 */ 
export function useThrottle(fn: (args?: any, b?: any, c?: any) => void, delay = 800) {
  // 上一次执行函数的时间戳，初始值为 0
  let lastTime = 0;
 
  // 返回一个闭包函数，作为节流后的函数
  return function(args?: any, b?: any, c?: any) {
    // 获取当前时间戳
    const now = Date.now();

    // 如果当前时间与上一次执行时间的差值大于等于 wait，则执行函数
    if (now - lastTime >= delay) {
      // 更新上一次执行函数的时间戳
      lastTime = now;
      // 调用原始函数，并传入参数
      fn(args, b, c);
    }
  };

}